import { getCurrentUser, userHasCap, userIsAdmin } from './Auth';
import { userHasFeature } from './Features';
import { getSetting } from './Settings';

export const shouldShowDownloadReasons = (share, files = [], collections = []) => {
  if (share) {
    return share.download_reasons;
  }

  if (!userHasFeature('download-reasons')) {
    return false;
  }

  if (!getSetting('download_reasons') || getSetting('download_reasons').length === 0) {
    return false;
  }

  if (getSetting('download_with_reasons')) {
    if (!getSetting('download_with_reasons_admins') && userIsAdmin()) {
      return false;
    }
    return true;
  }

  if (files.length > 0 && userHasCap('reason_download_files_and_collections')) {
    return true;
  }

  if (collections.length > 0 && userHasCap('reason_download_files_and_collections')) {
    return true;
  }

  return false;
};

export const translateAnswerTree = (answerTree) => {
  const translateTreeNode = (node) => ({
    ...(node.id && { id: node.id }),
    ...(node.question && { question: node.question }),
    ...(node.value && { value: node.value }),
    ...(node.answers && {
      answers: node.answers.map(a => (
        { id: a.id, label: a.label, value: a.value }
      )),
    }),
    ...(node.nodes && {
      nodes: node.nodes.map(n => Object.keys(n).map(k => translateTreeNode(n[k]))),
    }),
  });

  const translatedTree = Object.keys(answerTree).map(key => translateTreeNode(answerTree[key]));

  return translatedTree;
};

export const downloadReasonsEnabled = () => getSetting('download_reasons') && userHasFeature('download-reasons');

export const getDownloadReasons = (request) => {
  let reasons = [];
  if (request && getSetting('request_reasons') && getSetting('request_reasons').length > 0) {
    reasons = getSetting('request_reasons');
  }
  if (!request && getSetting('download_reasons') && getSetting('download_reasons').length > 0) {
    reasons = getSetting('download_reasons');
  }
  if (!request && !getCurrentUser()?.uuid && getSetting('download_reasons_anonymous') && getSetting('download_reasons_anonymous').length > 0) {
    reasons = getSetting('download_reasons_anonymous');
  }

  return reasons;
};
